<div class="details-modal-wrapper">
  <!-- HEADER COM STATUS E BOTÃO FECHAR -->
  <header class="modal-header">
    <div class="header-main-info">
      <div class="header-badges">
        <span class="badge-alerta-id">Alerta #{{ alert.alerta_id }}</span>
        
        <span class="badge-status" [class.badge-finalizado]="alert.respondido_em" [class.badge-pendente]="!alert.respondido_em">
          <mat-icon>{{ alert.respondido_em ? 'check_circle' : 'schedule' }}</mat-icon>
          {{ alert.respondido_em ? 'Finalizado' : 'Pendente' }}
        </span>

        <span class="badge-classificacao" [ngClass]="getClassificacaoBadgeClass()">
          <mat-icon>{{ alert.classificacao_id >= 3 ? 'warning' : 'info' }}</mat-icon>
          {{ getClassificacaoNome() }}
        </span>
      </div>

      <div class="header-patient">
        <h2 class="patient-name">{{ alert.paciente_nome }}</h2>
        <div class="patient-meta">
          <span class="meta-item">
            <mat-icon>local_hospital</mat-icon>
            {{ alert.unidade_nome || 'Unidade não informada' }}
          </span>
          @if (alert.telefone_whatsapp) {
            <span class="meta-item">
              <mat-icon>phone</mat-icon>
              {{ formatTelefone(alert.telefone_whatsapp) }}
            </span>
          }
        </div>
      </div>
    </div>

    <button
      class="btn-close-header"
      (click)="close()"
      aria-label="Fechar janela de detalhes"
      matTooltip="Fechar"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <!-- NAVEGAÇÃO POR TABS -->
  <mat-tab-group class="modern-tabs" animationDuration="200ms">
    <!-- ABA 1: INFORMAÇÕES DO ALERTA -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        Informações do Alerta
      </ng-template>

      <div class="tab-scroll-body">
        <!-- CARD DE DESTAQUE DA GLICEMIA -->
        <section class="glycemia-hero-card" [ngClass]="getGlicemiaStatus(alert.valor_medido).class">
          <div class="hero-icon-container">
            <mat-icon>water_drop</mat-icon>
          </div>
          <div class="hero-data">
            <span class="hero-label">Valor Medido</span>
            <div class="hero-value-row">
              <strong class="hero-value">{{ alert.valor_medido }}</strong>
              <span class="hero-unit">mg/dL</span>
            </div>
            <div class="hero-status-pill">
              <mat-icon class="text-sm">{{ getGlicemiaStatus(alert.valor_medido).icon }}</mat-icon>
              <span>{{ getGlicemiaStatus(alert.valor_medido).label }}</span>
            </div>
          </div>
        </section>

        <!-- GRID DE DETALHES DA MEDIÇÃO -->
        <div class="details-section-title">
          <mat-icon>analytics</mat-icon>
          <h3>Detalhes da Medição</h3>
        </div>

        <div class="info-grid">
          <div class="info-card-item">
            <div class="item-icon-wrapper icon-restaurant">
              <mat-icon>restaurant</mat-icon>
            </div>
            <div class="item-content">
              <label>Contexto / Refeição</label>
              <strong>{{ alert.contexto_nome || 'Não informado' }}</strong>
            </div>
          </div>

          <div class="info-card-item">
            <div class="item-icon-wrapper icon-calendar">
              <mat-icon>event</mat-icon>
            </div>
            <div class="item-content">
              <label>Data / Hora da Medição</label>
              <strong>{{ formatDateTime(alert.criado_em) }}</strong>
            </div>
          </div>

          <div class="info-card-item">
            <div class="item-icon-wrapper icon-clock">
              <mat-icon>schedule</mat-icon>
            </div>
            <div class="item-content">
              <label>Tempo Decorrido</label>
              <strong [class.text-red-600]="alert.status_tempo === 'ATRASADO'">
                {{ getTempoDecorrido() }}
              </strong>
            </div>
          </div>

          <div class="info-card-item">
            <div class="item-icon-wrapper icon-hospital">
              <mat-icon>local_hospital</mat-icon>
            </div>
            <div class="item-content">
              <label>Unidade de Saúde</label>
              <strong>{{ alert.unidade_nome || 'Não informada' }}</strong>
            </div>
          </div>

          <div class="info-card-item">
            <div class="item-icon-wrapper icon-shield">
              <mat-icon>shield</mat-icon>
            </div>
            <div class="item-content">
              <label>Classificação de Risco</label>
              <strong>{{ getClassificacaoNome() }}</strong>
            </div>
          </div>

          <div class="info-card-item">
            <div class="item-icon-wrapper icon-timer">
              <mat-icon>timer</mat-icon>
            </div>
            <div class="item-content">
              <label>Tempo de Resposta Máximo</label>
              <strong>{{ alert.tempo_resposta_max ? alert.tempo_resposta_max + ' minutos' : 'Conforme protocolo' }}</strong>
            </div>
          </div>
        </div>

        <!-- SE ALERTA ESTIVER FINALIZADO -->
        @if (alert.respondido_em) {
          <div class="finalization-card">
            <div class="finalization-header">
              <mat-icon>verified</mat-icon>
              <h4>Dados da Resolução do Alerta</h4>
            </div>

            <div class="info-grid mt-3">
              <div class="info-card-item">
                <div class="item-icon-wrapper icon-doctor">
                  <mat-icon>badge</mat-icon>
                </div>
                <div class="item-content">
                  <label>Responsável pelo Atendimento</label>
                  <strong>{{ alert.respondido_por_nome || 'Profissional de saúde' }}</strong>
                </div>
              </div>

              <div class="info-card-item">
                <div class="item-icon-wrapper icon-calendar">
                  <mat-icon>check_circle</mat-icon>
                </div>
                <div class="item-content">
                  <label>Finalizado em</label>
                  <strong>{{ formatDateTime(alert.respondido_em) }}</strong>
                </div>
              </div>
            </div>

            @if (alert.observacoes) {
              <div class="observacoes-container">
                <div class="obs-title">
                  <mat-icon>chat</mat-icon>
                  <span>Observações Clínicas Registradas:</span>
                </div>
                <p class="obs-text">{{ alert.observacoes }}</p>
              </div>
            }
          </div>
        }
      </div>
    </mat-tab>

    <!-- ABA 2: DADOS DO PACIENTE -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">person</mat-icon>
        Dados do Paciente
      </ng-template>

      <div class="tab-scroll-body">
        @if (loadingPatient) {
          <div class="loading-state">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Carregando prontuário do paciente...</p>
          </div>
        } @else if (patientData) {
          <!-- PERFIL DO PACIENTE -->
          <div class="patient-profile-card">
            <div class="avatar-circle">
              {{ patientData.nomeCompleto.charAt(0) }}
            </div>
            <div class="profile-main">
              <h3>{{ patientData.nomeCompleto }}</h3>
              <div class="profile-tags">
                <span class="tag-meta">
                  <mat-icon>cake</mat-icon>
                  {{ formatDate(patientData.data_nascimento) }} ({{ calcularIdade(patientData.data_nascimento) }} anos)
                </span>
                <span class="tag-meta">
                  <mat-icon>wc</mat-icon>
                  {{ patientData.sexo === 'M' ? 'Masculino' : 'Feminino' }}
                </span>
                <span class="tag-meta">
                  <mat-icon>badge</mat-icon>
                  CPF: {{ patientData.cpf || 'Não informado' }}
                </span>
              </div>
            </div>
            @if (alert.telefone_whatsapp) {
              <button mat-stroked-button class="btn-quick-wpp" (click)="openWhatsapp()" matTooltip="Iniciar conversa no WhatsApp">
                <mat-icon>chat</mat-icon>
                WhatsApp
              </button>
            }
          </div>

          <!-- DOENÇAS E HÁBITOS -->
          <div class="health-badges-section">
            <div class="badge-block">
              <label class="block-label">
                <mat-icon>coronavirus</mat-icon>
                Diagnósticos / Doenças Relatadas
              </label>
              <div class="chips-list">
                @if (patientData.doencas && patientData.doencas.length > 0) {
                  @for (doenca of patientData.doencas; track doenca.doenca_id) {
                    <span class="chip-item chip-danger">{{ doenca.doenca_descricao }}</span>
                  }
                } @else {
                  <span class="chip-empty">Nenhuma patologia registrada</span>
                }
              </div>
            </div>

            <div class="badge-block">
              <label class="block-label">
                <mat-icon>self_improvement</mat-icon>
                Hábitos e Estilo de Vida
              </label>
              <div class="chips-list">
                @if (patientData.habitos && patientData.habitos.length > 0) {
                  @for (habito of patientData.habitos; track habito.habito_id) {
                    <span class="chip-item chip-info">{{ habito.habito_descricao }}</span>
                  }
                } @else {
                  <span class="chip-empty">Nenhum hábito cadastrado</span>
                }
              </div>
            </div>
          </div>

          <!-- DADOS ANTROPOMÉTRICOS -->
          <div class="details-section-title mt-4">
            <mat-icon>monitor_weight</mat-icon>
            <h3>Dados Antropométricos</h3>
          </div>

          <div class="anthropometric-grid">
            <div class="anthro-card">
              <span class="anthro-label">Peso</span>
              <strong class="anthro-value">{{ patientData.peso || '--' }} <span class="unit">kg</span></strong>
            </div>

            <div class="anthro-card">
              <span class="anthro-label">Altura</span>
              <strong class="anthro-value">{{ patientData.altura || '--' }} <span class="unit">m</span></strong>
            </div>

            <div class="anthro-card" [ngClass]="getImcClass(patientData.imc).colorClass">
              <span class="anthro-label">IMC</span>
              <strong class="anthro-value">{{ patientData.imc ? (patientData.imc | number:'1.1-2') : '--' }}</strong>
              <span class="anthro-status">{{ getImcClass(patientData.imc).label }}</span>
            </div>
          </div>

          <!-- ENDEREÇO -->
          <div class="details-section-title mt-4">
            <mat-icon>home</mat-icon>
            <h3>Endereço</h3>
          </div>

          <div class="address-card">
            <mat-icon class="address-icon">location_on</mat-icon>
            <div class="address-content">
              <p class="address-street">
                {{ patientData.logradouro || 'Logradouro não informado' }}, {{ patientData.numero || 'S/N' }}
              </p>
              <p class="address-city">
                {{ patientData.bairro || 'Bairro' }} — {{ patientData.cidade || 'Cidade' }}
              </p>
            </div>
          </div>

          <!-- CONVÊNIOS -->
          @if (patientData.convenios && patientData.convenios.length > 0) {
            <div class="details-section-title mt-4">
              <mat-icon>medical_services</mat-icon>
              <h3>Convênios de Saúde</h3>
            </div>

            <div class="convenios-grid">
              @for (conv of patientData.convenios; track conv.id_convenio) {
                <div class="convenio-card">
                  <strong>{{ conv.descricao }}</strong>
                  <span>Matrícula: {{ conv.num_identificacao }}</span>
                </div>
              }
            </div>
          }

          <!-- HISTÓRICO CLÍNICO -->
          @if (patientData.historico_clinico) {
            <div class="details-section-title mt-4">
              <mat-icon>notes</mat-icon>
              <h3>Histórico Clínico Adicional</h3>
            </div>
            <div class="history-box">
              <p>{{ patientData.historico_clinico }}</p>
            </div>
          }

          <!-- CONSENTIMENTO -->
          @if (patientData.consentimento_aceito) {
            <div class="consent-alert">
              <mat-icon>verified</mat-icon>
              <span>Termo de consentimento aceito pelo paciente em {{ formatDate(patientData.data_consentimento) }}</span>
            </div>
          }
        } @else {
          <div class="empty-tab-state">
            <mat-icon>person_off</mat-icon>
            <h4>Dados do paciente não encontrados</h4>
            <p>Não foi possível recuperar o histórico cadastral deste paciente.</p>
          </div>
        }
      </div>
    </mat-tab>

    <!-- ABA 3: HISTÓRICO DE MEDIÇÕES -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">history</mat-icon>
        Histórico de Medições
      </ng-template>

      <div class="tab-scroll-body">
        @if (loadingHistory) {
          <div class="loading-state">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Carregando histórico de medições...</p>
          </div>
        } @else if (measurementHistory && measurementHistory.length > 0) {
          <div class="measurements-timeline">
            @for (med of measurementHistory; track med.id) {
              <div class="timeline-row">
                <div class="timeline-badge" [ngClass]="getGlicemiaStatus(+med.valor).class">
                  <mat-icon>water_drop</mat-icon>
                  <span class="value">{{ med.valor }}</span>
                  <span class="unit">{{ med.unidade_de_medida || 'mg/dL' }}</span>
                </div>

                <div class="timeline-details">
                  <div class="timeline-meta">
                    <span class="time-item">
                      <mat-icon>event</mat-icon>
                      {{ formatDate(med.data_medicao) }} às {{ med.hora_medicao }}
                    </span>
                    <span class="context-pill">
                      <mat-icon>restaurant</mat-icon>
                      {{ med.contexto || 'Geral' }}
                    </span>
                  </div>
                  <span class="status-name" [ngClass]="getGlicemiaStatus(+med.valor).class">
                    {{ getGlicemiaStatus(+med.valor).label }}
                  </span>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="empty-tab-state">
            <mat-icon>timeline</mat-icon>
            <h4>Nenhuma medição anterior</h4>
            <p>Este paciente ainda não possui outras medições registradas no histórico.</p>
          </div>
        }
      </div>
    </mat-tab>
  </mat-tab-group>

  <!-- FOOTER COM AÇÕES RÁPIDAS -->
  <footer class="modal-footer">
    <div class="footer-left">
      @if (!alert.respondido_em && alert.telefone_whatsapp) {
        <button mat-stroked-button class="btn-wpp-footer" (click)="openWhatsapp()">
          <mat-icon>chat</mat-icon>
          Contatar via WhatsApp
        </button>
      }
    </div>

    <div class="footer-right">
      <button mat-flat-button class="btn-close-modal" (click)="close()">
        Fechar
      </button>
    </div>
  </footer>
</div>
